// extracted by mini-css-extract-plugin
export default {"sidebarDefault":"Sticky_sidebarDefault__5akJF","sidebarNoHeader":"Sticky_sidebarNoHeader__LlVYp"};